import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';

let startDate = moment().startOf('year');
let endDate = moment().startOf('month');

//화면 진입시 초기화
const getInit = () => {
	return {
		searchParams: {
			srchMm01: '30', //판매월
			srchMm02: '20', //조건월
			// plntCd: 'HCJ1', //생산공장
			carScn: '', //차량구분
			pacScn: '', //승상구분
			flclSpc: '', //연료전지사양
			phmnCd: '', //현상코드
			ctype: '', //클레임타입
			// customPrCor: 'HTWO', //생산법인
			// saleNat: '', //판매국가
			occuRegn: '', //판매지역
			partG: '', //부품유형
			partNo: '', //품번
			idxScn: '', //지수구분
			opCd: '', //작업코드
			carTypeNm: '', //차종유형

			strtMm01: startDate, //strtMm01
			endMm01: endDate, //endMm01
			strtMm02: startDate, //strtMm02
			endMm02: endDate //endMm011
		},
		pcQrtyList: [], //그리드리스트
		dayCols: [], //그리드 컬럼(년월컬럼)
		graphBarStackChartInfo: [], //그래프 스택 임시저장소
		graphLineChartInfo: [], //라인차트 임시저장소

		srchMm01List: [], //검색 판매월 셀렉트박스
		srchMm02List: [], //검색 조건월 셀렉트박스
		plntCdList: [], //검색 생산공장 셀렉트박스
		carScnList: [], //검색 차량구분 셀렉트박스
		pacScnList: [], //검색 승상구분 셀렉트박스
		flclSpcList: [], //검색 연료전지사양 셀렉트박스
		phmnCdList: [], //검색 현상코드 셀렉트박스
		cTypeList: [], //검색 클레임타입 셀렉트박스
		customPrCorList: [], //검색 생산법인 커스텀 셀렉트박스
		saleNatList: [], //검색 판매국가 셀렉트박스
		occuRegnList: [], //검색 발생지역 셀렉트박스
		carTypeNmList: [], //검색 차종유형 셀렉트박스
		idxScnList: [], //검색 지수구분 셀렉트박스
		opCdList: [], //검색 작업코드 셀렉트박스
		partTypeList: [] //검색 부품유형 셀렉트박스
	};
};
const selectDate1 = (state, { from, to }) => {
	state.searchParams.strtMm01 = from;
	state.searchParams.endMm01 = to;
};
const selectDate2 = (state, { from, to }) => {
	state.searchParams.strtMm02 = from;
	state.searchParams.endMm02 = to;
};

export default {
	...common,
	selectDate1,
	selectDate2,
	[types.STATE_INIT]: state => {
		//초기화
		Object.assign(state, getInit());
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	}
};
